import { observer } from 'mobx-react-lite'

import type { CollectionRef } from '../../../api/useCollection'
import { groupStore } from '../../../store/GroupStore'
import { useMediaObjectStore } from '../../../store/PhotoContext'
import { MediaThumb } from '../../PhotoGallery/MediaThumb'

export interface AlbumPhotoThumbProps {
  id: string
  showOwnerAvatar?: boolean
  comments?: number
  showSimilarSearch?: boolean
  collectionRef?: CollectionRef
}

export const AlbumPhotoThumb = observer<AlbumPhotoThumbProps>(
  function AlbumPhotoThumb({
    id,
    showOwnerAvatar = false,
    showSimilarSearch = false,
    collectionRef,
  }) {
    const store = useMediaObjectStore()
    const photo = store.getPhoto(id)

    if (!photo) {
      return null
    }

    return (
      <MediaThumb
        photo={photo}
        showOwnerAvatar={showOwnerAvatar}
        filename={photo.filename}
        ownerAvatar={photo.ownerAvatar}
        comments={groupStore.getCommentCount(photo.commentsItemId)}
        src={`${photo.thumbnail_url}.s`}
        playIcon={photo.content === 'video'}
        duration={photo.duration}
        showSimilarSearch={showSimilarSearch}
        collectionRef={collectionRef}
      />
    )
  },
)
